class ModelParamCollection {
    option: Element;

    height: Element;

    auto: Element;

    material: Element;

    constructor(option: Element = null, height: Element = null, auto: Element = null, material: Element = null) {
      this.option = option;
      this.height = height;
      this.auto = auto;
      this.material = material;
    }
}
export default ModelParamCollection;
